import { t } from '@web/i18n';
import { DangerZoneCard, Scaffold } from '@web/ui/core';

export function SquadSettingsPage(): React.JSX.Element {
  return (
    <Scaffold
      body={
        <>
          <div className="mb-3.5">
            <h4 className="m-0 text-base font-medium text-foreground">
              {t('squad.editor.settings.title')}
            </h4>
            <p className="m-0 text-meta text-muted-foreground">{t('squad.editor.settings.hint')}</p>
          </div>

          <DangerZoneCard
            label={t('squad.editor.settings.danger.label')}
            title={t('squad.editor.settings.danger.title')}
            sub={t('squad.editor.settings.danger.sub')}
            buttonLabel={t('squad.editor.settings.danger.button')}
            disabled
          />
        </>
      }
    />
  );
}
